export const OPTIONS = [
  { label: "-", value: 0 },
  { label: "데이", value: 1, short: "D" },
  { label: "이브닝", value: 2, short: "E" },
  { label: "나이트", value: 3, short: "N" },
] as const;

// Default
export const DEFAULT_SHIFT = {
  D: "데이",
  E: "이브닝",
  N: "나이트",
};
